export default __webpack_public_path__ + "static/media/dic.1a9159cb.jfif";